"use client";

import { type ComponentType } from "react";

import { animated, useTransition } from "@react-spring/web";

import { type Mode } from "@demo/constants/mode";
import ComposeSurface from "@demo/features/compose";
import DetectSurface from "@demo/features/detect";
import { useGlobalDragDropPrevention } from "@demo/hooks/useDropZone";
import { useMode } from "@demo/hooks/useMode";

const SURFACES: Record<Mode, ComponentType> = {
  compose: ComposeSurface,
  detect: DetectSurface,
};

const ModeSurface = () => {
  const [mode] = useMode();

  // A file dropped outside a [data-drop-zone] would otherwise navigate the
  // browser to the local file, tearing down the whole session.
  useGlobalDragDropPrevention();

  const transitions = useTransition(mode, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 200 },
    exitBeforeEnter: true,
  });

  return (
    <div className="relative min-h-0 w-full flex-1">
      {transitions((style, value) => {
        const Surface = SURFACES[value];
        return (
          <animated.div className="absolute inset-0 flex flex-col" style={style}>
            <Surface />
          </animated.div>
        );
      })}
    </div>
  );
};

export default ModeSurface;
